// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-05: Settings modal styles.
 * Premium, glassmorphism, responsive, mobile touch targets.
 */

.vnsc-settings-backdrop {
	position: fixed;
	inset: 0;
	z-index: 1000;
	background: rgba(2, 6, 23, 0.6);
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	animation: vnsc-reveal 200ms ease-out;
}

.vnsc-settings-backdrop[data-chart-mode="light"] {
	background: rgba(15, 23, 42, 0.35);
}

.vnsc-settings-backdrop[data-chart-mode="light"] .vnsc-settings-modal {
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

@keyframes vnsc-reveal {
	from {
		opacity: 0;
		transform: translateY(8px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.vnsc-settings-modal {
	background: var(--vnsc-bg-primary, #0a0e14);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: var(--vnsc-radius-xl, 8px);
	width: 520px;
	max-width: 100%;
	max-height: 80vh;
	display: flex;
	flex-direction: column;
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
	overflow: hidden;
}

.vnsc-settings-modal__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
	background: linear-gradient(180deg, var(--vnsc-bg-secondary, #111820), var(--vnsc-bg-primary, #0a0e14));
	flex-shrink: 0;
}

.vnsc-settings-modal__title {
	margin: 0;
	font-size: var(--vnsc-font-lg, 15px);
	font-weight: 700;
	color: var(--vnsc-text-primary, #e0e0e0);
	letter-spacing: -0.01em;
}

.vnsc-settings-modal__close {
	background: none;
	border: none;
	color: var(--vnsc-text-secondary, #a0a0a0);
	cursor: pointer;
	font-size: 22px;
	padding: 4px;
	line-height: 1;
	transition: color 120ms ease;
}

.vnsc-settings-modal__close:hover {
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-settings-tabs {
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 8px 16px;
	height: 50px;
	box-sizing: border-box;
	border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
	overflow-x: auto;
	scrollbar-width: none;
	flex-shrink: 0;
}

.vnsc-settings-tabs::-webkit-scrollbar {
	display: none;
}

.vnsc-settings-tab {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 34px;
	line-height: 1;
	padding: 0 12px;
	box-sizing: border-box;
	border: none;
	border-radius: var(--vnsc-radius-md, 4px);
	background: transparent;
	color: var(--vnsc-text-secondary, #a0a0a0);
	cursor: pointer;
	font-family: inherit;
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	flex-shrink: 0;
	transition: background 120ms ease, color 120ms ease;
}

.vnsc-settings-tab:hover {
	background: var(--vnsc-bg-tertiary, #1c2430);
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-settings-tab--active {
	background: var(--vnsc-accent, #2962ff);
	color: #fff !important;
}

.vnsc-settings-body {
	flex: 1;
	overflow-y: auto;
	min-height: 0;
	padding: 16px;
	scrollbar-gutter: stable;
}

/* Scrollbars */
.vnsc-settings-body::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}
.vnsc-settings-body::-webkit-scrollbar-thumb {
	background: var(--vnsc-border, #2a2a2a);
	border-radius: 3px;
}

/* Form layouts */
.vnsc-settings-panel {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.vnsc-settings-panel__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}

.vnsc-settings-panel__header--subtle {
	border-top: 1px solid var(--vnsc-border, #2a2a2a);
	margin-top: 12px;
	padding-top: 12px;
}

.vnsc-settings-kicker {
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-settings-row {
	display: flex;
	align-items: flex-end;
	gap: 12px;
	flex-wrap: wrap;
}

.vnsc-settings-row--split {
	justify-content: space-between;
	align-items: center;
}

.vnsc-settings-field {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	font-size: 11px;
	font-weight: 600;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-settings-field--compact {
	min-width: 120px;
}

.vnsc-settings-input,
.vnsc-settings-select {
	width: 100%;
	padding: 8px 10px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: 4px;
	background: var(--vnsc-bg-secondary, #111820);
	color: var(--vnsc-text-primary, #e0e0e0);
	font-size: 12px;
	outline: none;
	box-sizing: border-box;
	transition: border-color 120ms ease, background 120ms ease;
}

.vnsc-settings-input:focus,
.vnsc-settings-select:focus {
	border-color: var(--vnsc-accent, #2962ff);
	background: var(--vnsc-bg-tertiary, #1c2430);
}

.vnsc-settings-select {
	cursor: pointer;
}

/* Pane/Indicator cards */
.vnsc-settings-pane-list,
.vnsc-settings-series-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 8px;
}

.vnsc-settings-series {
	padding: 10px 12px;
	background: var(--vnsc-bg-secondary, #111820);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.vnsc-settings-series__head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
}

.vnsc-settings-series__title {
	font-size: 12px;
	font-weight: 700;
	color: var(--vnsc-text-primary, #e0e0e0);
}

.vnsc-settings-series__meta {
	font-size: 10px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	margin-top: 2px;
}

.vnsc-settings-series__actions {
	display: flex;
	gap: 6px;
	align-items: center;
}

.vnsc-settings-pane__tags {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 4px;
}

.vnsc-tag {
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	border-radius: 3px;
	background: var(--vnsc-bg-primary, #0a0e14);
	color: var(--vnsc-text-secondary, #a0a0a0);
	border: 1px solid var(--vnsc-border, #2a2a2a);
	font-size: 10px;
	font-weight: 500;
}

.vnsc-settings-note {
	font-size: 11px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	background: rgba(41, 98, 255, 0.08);
	border: 1px dashed rgba(41, 98, 255, 0.25);
	padding: 8px 12px;
	border-radius: 4px;
	margin: 6px 0;
	line-height: 1.4;
}

.vnsc-settings-empty {
	text-align: center;
	color: var(--vnsc-text-secondary, #a0a0a0);
	padding: 20px;
	font-size: 12px;
}

.vnsc-btn {
	padding: 6px 12px;
	font-size: 12px;
	font-weight: 600;
	border-radius: 4px;
	border: 1px solid var(--vnsc-border, #2a2a2a);
	background: var(--vnsc-bg-secondary, #111820);
	color: var(--vnsc-text-primary, #e0e0e0);
	cursor: pointer;
	transition: all 120ms ease;
	outline: none;
}

.vnsc-btn:hover:not(:disabled) {
	background: var(--vnsc-bg-tertiary, #1c2430);
	border-color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.vnsc-btn--accent {
	background: var(--vnsc-accent, #2962ff);
	color: #fff;
	border-color: transparent;
}

.vnsc-btn--accent:hover:not(:disabled) {
	background: #1565c0;
	opacity: 0.95;
}

.vnsc-btn--danger {
	background: rgba(244, 67, 54, 0.15);
	color: #ef5350;
	border-color: rgba(244, 67, 54, 0.3);
}

.vnsc-btn--danger:hover:not(:disabled) {
	background: #f44336;
	color: #fff;
	border-color: transparent;
}

/* Slider Customizations */
.vnsc-settings-slider-shell {
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
}

.vnsc-settings-slider-readout {
	display: flex;
	justify-content: space-between;
	font-size: 10px;
	color: var(--vnsc-text-secondary, #a0a0a0);
}

.vnsc-settings-slider-readout__current {
	color: var(--vnsc-accent, #2962ff);
	font-weight: 700;
}

/* ── CE21: Mobile Responsive Styles (≤520px) ───────────────────────── */
@media (max-width: 520px) {
	.vnsc-settings-backdrop {
		padding: 8px;
		align-items: flex-end; /* Slide up dialog from bottom */
	}

	.vnsc-settings-modal {
		width: 100%;
		max-height: 90vh;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		animation: vnsc-slide-up 240ms cubic-bezier(0.16, 1, 0.3, 1);
	}

	@keyframes vnsc-slide-up {
		from {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}

	.vnsc-settings-modal__header {
		padding: 14px 16px;
	}

	.vnsc-settings-tabs {
		padding: 8px 16px;
		gap: 6px;
		height: 50px;
		flex-shrink: 0;
	}



	.vnsc-settings-body {
		padding: 14px;
	}

	/* Force buttons to meet 44px min-height target */
	.vnsc-btn,
	.vnsc-settings-input,
	.vnsc-settings-select {
		min-height: 44px;
		font-size: 13px;
	}

	/* Adjust stack layouts */
	.vnsc-settings-row {
		flex-direction: column;
		align-items: stretch;
		gap: 10px;
	}

	.vnsc-settings-row > .vnsc-btn {
		margin-top: 0 !important;
	}
	
	.vnsc-settings-series__head {
		flex-direction: column;
		align-items: stretch;
		gap: 10px;
	}

	.vnsc-settings-series__actions {
		justify-content: flex-end;
		width: 100%;
	}

	.vnsc-settings-series__actions > select,
	.vnsc-settings-series__actions > button {
		flex: 1;
		min-height: 38px;
		font-size: 12px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/settings.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;CACC,eAAe;CACf,QAAQ;CACR,aAAa;CACb,+BAA+B;CAC/B,0BAA0B;CAC1B,kCAAkC;CAClC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC;EACC,UAAU;EACV,0BAA0B;CAC3B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;CACC,2CAA2C;CAC3C,6CAA6C;CAC7C,yCAAyC;CACzC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,oDAAoD;CACpD,uGAAuG;CACvG,cAAc;AACf;;AAEA;CACC,SAAS;CACT,oCAAoC;CACpC,gBAAgB;CAChB,wCAAwC;CACxC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,0CAA0C;CAC1C,eAAe;CACf,eAAe;CACf,YAAY;CACZ,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;CACjB,YAAY;CACZ,sBAAsB;CACtB,oDAAoD;CACpD,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,cAAc;CACd,eAAe;CACf,sBAAsB;CACtB,YAAY;CACZ,yCAAyC;CACzC,uBAAuB;CACvB,0CAA0C;CAC1C,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd,mDAAmD;AACpD;;AAEA;CACC,4CAA4C;CAC5C,wCAAwC;AACzC;;AAEA;CACC,uCAAuC;CACvC,sBAAsB;AACvB;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,aAAa;CACb,aAAa;CACb,wBAAwB;AACzB;;AAEA,eAAe;AACf;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA,iBAAiB;AACjB;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,iDAAiD;CACjD,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,0CAA0C;AAC3C;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,iBAAiB;CACjB,6CAA6C;CAC7C,kBAAkB;CAClB,6CAA6C;CAC7C,wCAAwC;CACxC,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,0DAA0D;AAC3D;;AAEA;;CAEC,yCAAyC;CACzC,4CAA4C;AAC7C;;AAEA;CACC,eAAe;AAChB;;AAEA,yBAAyB;AACzB;;CAEC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,6CAA6C;CAC7C,6CAA6C;CAC7C,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;AACzC;;AAEA;CACC,eAAe;CACf,0CAA0C;CAC1C,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,2CAA2C;CAC3C,0CAA0C;CAC1C,6CAA6C;CAC7C,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,0CAA0C;CAC1C,mCAAmC;CACnC,0CAA0C;CAC1C,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,0CAA0C;CAC1C,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,6CAA6C;CAC7C,6CAA6C;CAC7C,wCAAwC;CACxC,eAAe;CACf,0BAA0B;CAC1B,aAAa;AACd;;AAEA;CACC,4CAA4C;CAC5C,iDAAiD;AAClD;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,mCAAmC;CACnC,cAAc;CACd,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,yBAAyB;AAC1B;;AAEA,0BAA0B;AAC1B;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,eAAe;CACf,0CAA0C;AAC3C;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA,yEAAyE;AACzE;CACC;EACC,YAAY;EACZ,qBAAqB,EAAE,gCAAgC;CACxD;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,4DAA4D;CAC7D;;CAEA;EACC;GACC,2BAA2B;EAC5B;EACA;GACC,wBAAwB;EACzB;CACD;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,cAAc;CACf;;;;CAIA;EACC,aAAa;CACd;;CAEA,iDAAiD;CACjD;;;EAGC,gBAAgB;EAChB,eAAe;CAChB;;CAEA,yBAAyB;CACzB;EACC,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;CACV;;CAEA;EACC,yBAAyB;EACzB,WAAW;CACZ;;CAEA;;EAEC,OAAO;EACP,gBAAgB;EAChB,eAAe;CAChB;AACD","sourcesContent":["/**\r\n * WE2 P4-05: Settings modal styles.\r\n * Premium, glassmorphism, responsive, mobile touch targets.\r\n */\r\n\r\n.vnsc-settings-backdrop {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tz-index: 1000;\r\n\tbackground: rgba(2, 6, 23, 0.6);\r\n\tbackdrop-filter: blur(6px);\r\n\t-webkit-backdrop-filter: blur(6px);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 16px;\r\n\tanimation: vnsc-reveal 200ms ease-out;\r\n}\r\n\r\n.vnsc-settings-backdrop[data-chart-mode=\"light\"] {\r\n\tbackground: rgba(15, 23, 42, 0.35);\r\n}\r\n\r\n.vnsc-settings-backdrop[data-chart-mode=\"light\"] .vnsc-settings-modal {\r\n\tbox-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n@keyframes vnsc-reveal {\r\n\tfrom {\r\n\t\topacity: 0;\r\n\t\ttransform: translateY(8px);\r\n\t}\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateY(0);\r\n\t}\r\n}\r\n\r\n.vnsc-settings-modal {\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: var(--vnsc-radius-xl, 8px);\r\n\twidth: 520px;\r\n\tmax-width: 100%;\r\n\tmax-height: 80vh;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbox-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-settings-modal__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 12px 16px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: linear-gradient(180deg, var(--vnsc-bg-secondary, #111820), var(--vnsc-bg-primary, #0a0e14));\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-settings-modal__title {\r\n\tmargin: 0;\r\n\tfont-size: var(--vnsc-font-lg, 15px);\r\n\tfont-weight: 700;\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tletter-spacing: -0.01em;\r\n}\r\n\r\n.vnsc-settings-modal__close {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tcursor: pointer;\r\n\tfont-size: 22px;\r\n\tpadding: 4px;\r\n\tline-height: 1;\r\n\ttransition: color 120ms ease;\r\n}\r\n\r\n.vnsc-settings-modal__close:hover {\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-settings-tabs {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tpadding: 8px 16px;\r\n\theight: 50px;\r\n\tbox-sizing: border-box;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n\toverflow-x: auto;\r\n\tscrollbar-width: none;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-settings-tabs::-webkit-scrollbar {\r\n\tdisplay: none;\r\n}\r\n\r\n.vnsc-settings-tab {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\theight: 34px;\r\n\tline-height: 1;\r\n\tpadding: 0 12px;\r\n\tbox-sizing: border-box;\r\n\tborder: none;\r\n\tborder-radius: var(--vnsc-radius-md, 4px);\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tcursor: pointer;\r\n\tfont-family: inherit;\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n\twhite-space: nowrap;\r\n\tflex-shrink: 0;\r\n\ttransition: background 120ms ease, color 120ms ease;\r\n}\r\n\r\n.vnsc-settings-tab:hover {\r\n\tbackground: var(--vnsc-bg-tertiary, #1c2430);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-settings-tab--active {\r\n\tbackground: var(--vnsc-accent, #2962ff);\r\n\tcolor: #fff !important;\r\n}\r\n\r\n.vnsc-settings-body {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tmin-height: 0;\r\n\tpadding: 16px;\r\n\tscrollbar-gutter: stable;\r\n}\r\n\r\n/* Scrollbars */\r\n.vnsc-settings-body::-webkit-scrollbar {\r\n\twidth: 6px;\r\n\theight: 6px;\r\n}\r\n.vnsc-settings-body::-webkit-scrollbar-thumb {\r\n\tbackground: var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: 3px;\r\n}\r\n\r\n/* Form layouts */\r\n.vnsc-settings-panel {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n}\r\n\r\n.vnsc-settings-panel__header {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.vnsc-settings-panel__header--subtle {\r\n\tborder-top: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tmargin-top: 12px;\r\n\tpadding-top: 12px;\r\n}\r\n\r\n.vnsc-settings-kicker {\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.08em;\r\n\ttext-transform: uppercase;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-settings-row {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tgap: 12px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.vnsc-settings-row--split {\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n}\r\n\r\n.vnsc-settings-field {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 4px;\r\n\tmin-width: 0;\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-settings-field--compact {\r\n\tmin-width: 120px;\r\n}\r\n\r\n.vnsc-settings-input,\r\n.vnsc-settings-select {\r\n\twidth: 100%;\r\n\tpadding: 8px 10px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: 4px;\r\n\tbackground: var(--vnsc-bg-secondary, #111820);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tfont-size: 12px;\r\n\toutline: none;\r\n\tbox-sizing: border-box;\r\n\ttransition: border-color 120ms ease, background 120ms ease;\r\n}\r\n\r\n.vnsc-settings-input:focus,\r\n.vnsc-settings-select:focus {\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n\tbackground: var(--vnsc-bg-tertiary, #1c2430);\r\n}\r\n\r\n.vnsc-settings-select {\r\n\tcursor: pointer;\r\n}\r\n\r\n/* Pane/Indicator cards */\r\n.vnsc-settings-pane-list,\r\n.vnsc-settings-series-list {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n.vnsc-settings-series {\r\n\tpadding: 10px 12px;\r\n\tbackground: var(--vnsc-bg-secondary, #111820);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tborder-radius: 4px;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n}\r\n\r\n.vnsc-settings-series__head {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.vnsc-settings-series__title {\r\n\tfont-size: 12px;\r\n\tfont-weight: 700;\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.vnsc-settings-series__meta {\r\n\tfont-size: 10px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.vnsc-settings-series__actions {\r\n\tdisplay: flex;\r\n\tgap: 6px;\r\n\talign-items: center;\r\n}\r\n\r\n.vnsc-settings-pane__tags {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 4px;\r\n\tmargin-top: 4px;\r\n}\r\n\r\n.vnsc-tag {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: 3px;\r\n\tbackground: var(--vnsc-bg-primary, #0a0e14);\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tfont-size: 10px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.vnsc-settings-note {\r\n\tfont-size: 11px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tbackground: rgba(41, 98, 255, 0.08);\r\n\tborder: 1px dashed rgba(41, 98, 255, 0.25);\r\n\tpadding: 8px 12px;\r\n\tborder-radius: 4px;\r\n\tmargin: 6px 0;\r\n\tline-height: 1.4;\r\n}\r\n\r\n.vnsc-settings-empty {\r\n\ttext-align: center;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\tpadding: 20px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.vnsc-btn {\r\n\tpadding: 6px 12px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--vnsc-border, #2a2a2a);\r\n\tbackground: var(--vnsc-bg-secondary, #111820);\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tcursor: pointer;\r\n\ttransition: all 120ms ease;\r\n\toutline: none;\r\n}\r\n\r\n.vnsc-btn:hover:not(:disabled) {\r\n\tbackground: var(--vnsc-bg-tertiary, #1c2430);\r\n\tborder-color: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-btn:disabled {\r\n\topacity: 0.5;\r\n\tcursor: not-allowed;\r\n}\r\n\r\n.vnsc-btn--accent {\r\n\tbackground: var(--vnsc-accent, #2962ff);\r\n\tcolor: #fff;\r\n\tborder-color: transparent;\r\n}\r\n\r\n.vnsc-btn--accent:hover:not(:disabled) {\r\n\tbackground: #1565c0;\r\n\topacity: 0.95;\r\n}\r\n\r\n.vnsc-btn--danger {\r\n\tbackground: rgba(244, 67, 54, 0.15);\r\n\tcolor: #ef5350;\r\n\tborder-color: rgba(244, 67, 54, 0.3);\r\n}\r\n\r\n.vnsc-btn--danger:hover:not(:disabled) {\r\n\tbackground: #f44336;\r\n\tcolor: #fff;\r\n\tborder-color: transparent;\r\n}\r\n\r\n/* Slider Customizations */\r\n.vnsc-settings-slider-shell {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 6px;\r\n\twidth: 100%;\r\n}\r\n\r\n.vnsc-settings-slider-readout {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tfont-size: 10px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.vnsc-settings-slider-readout__current {\r\n\tcolor: var(--vnsc-accent, #2962ff);\r\n\tfont-weight: 700;\r\n}\r\n\r\n/* ── CE21: Mobile Responsive Styles (≤520px) ───────────────────────── */\r\n@media (max-width: 520px) {\r\n\t.vnsc-settings-backdrop {\r\n\t\tpadding: 8px;\r\n\t\talign-items: flex-end; /* Slide up dialog from bottom */\r\n\t}\r\n\r\n\t.vnsc-settings-modal {\r\n\t\twidth: 100%;\r\n\t\tmax-height: 90vh;\r\n\t\tborder-bottom-left-radius: 0;\r\n\t\tborder-bottom-right-radius: 0;\r\n\t\tanimation: vnsc-slide-up 240ms cubic-bezier(0.16, 1, 0.3, 1);\r\n\t}\r\n\r\n\t@keyframes vnsc-slide-up {\r\n\t\tfrom {\r\n\t\t\ttransform: translateY(100%);\r\n\t\t}\r\n\t\tto {\r\n\t\t\ttransform: translateY(0);\r\n\t\t}\r\n\t}\r\n\r\n\t.vnsc-settings-modal__header {\r\n\t\tpadding: 14px 16px;\r\n\t}\r\n\r\n\t.vnsc-settings-tabs {\r\n\t\tpadding: 8px 16px;\r\n\t\tgap: 6px;\r\n\t\theight: 50px;\r\n\t\tflex-shrink: 0;\r\n\t}\r\n\r\n\r\n\r\n\t.vnsc-settings-body {\r\n\t\tpadding: 14px;\r\n\t}\r\n\r\n\t/* Force buttons to meet 44px min-height target */\r\n\t.vnsc-btn,\r\n\t.vnsc-settings-input,\r\n\t.vnsc-settings-select {\r\n\t\tmin-height: 44px;\r\n\t\tfont-size: 13px;\r\n\t}\r\n\r\n\t/* Adjust stack layouts */\r\n\t.vnsc-settings-row {\r\n\t\tflex-direction: column;\r\n\t\talign-items: stretch;\r\n\t\tgap: 10px;\r\n\t}\r\n\r\n\t.vnsc-settings-row > .vnsc-btn {\r\n\t\tmargin-top: 0 !important;\r\n\t}\r\n\t\r\n\t.vnsc-settings-series__head {\r\n\t\tflex-direction: column;\r\n\t\talign-items: stretch;\r\n\t\tgap: 10px;\r\n\t}\r\n\r\n\t.vnsc-settings-series__actions {\r\n\t\tjustify-content: flex-end;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.vnsc-settings-series__actions > select,\r\n\t.vnsc-settings-series__actions > button {\r\n\t\tflex: 1;\r\n\t\tmin-height: 38px;\r\n\t\tfont-size: 12px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
